<template>
  <div class="rc-base-lookup plat-base-lookup">
    <!-- 新增按钮展示在【只读、禁用】时不展示 -->
    <div v-if="enableAdd && !readonly && !disabled" class="rc-base-lookup-add">
      <rc-icon slot="suffix" name="rt-saas-add" size="10"></rc-icon>
      <div @click="showAddForm">{{ $_t('common.add', '新增') }}</div>
    </div>
    <div
      v-if="
        lookupValue &&
        lookupValue.id &&
        (entity == 'systemuser' ||
          entity == 'new_srv_worker' ||
          entity == 'businessunit')
      "
      class="rc-lookup-qywx"
    >
      <rt-ww-open-data
        v-if="entity == 'businessunit'"
        type="departmentName"
        :openid="lookupValueName"
      />
      <rt-ww-open-data v-else type="userName" :openid="lookupValueName" />
      <span
        v-if="!readonly && !disabled"
        class="el-input__suffix"
        @click="clearData"
      >
        <span class="el-input__suffix-inner">
          <i class="el-input__icon el-icon-circle-close"></i>
        </span>
      </span>
    </div>
    <el-autocomplete
      v-else
      v-show="!showJump"
      v-model="lookupValueName"
      :popper-class="lookupKey"
      :placeholder="placeholderValue"
      :disabled="disabled || readonly"
      :trigger-on-focus="false"
      :fetch-suggestions="findValueByApi"
      class="plat-base-input"
      :readonly="closeQuickQuery"
      @blur="blur"
      @select="selectValue"
      @focus="focus"
      @input="changeLookupValueName"
    >
      <rc-icon
        v-if="!disabled && !readonly"
        slot="suffix"
        name="rt-base-lookup"
        @click="showLookupDialog"
      >
      </rc-icon>
      <slot slot="prefix" name="prefix" />
    </el-autocomplete>
    <div class="rt-input-shadow"></div>

    <div v-show="showJump" :class="lookupValueReadOnly">
      <span
        class="jumpSpan"
        @click="jumpNeedTips"
        >{{ lookupValueName }}</span
      >
      <div class="suffix-icon-wrap">
        <rc-icon
          v-if="!disabled && !readonly"
          slot="suffix"
          class="lookup"
          name="rt-base-lookup"
          @click="showLookupDialog"
        >
        </rc-icon>
      </div>
      <slot name="prefix" />
    </div>

    <rt-lookup-dialog
      ref="lookupDialog"
      :entity="entity"
      :is-normal="isNormal"
      :request-url="requestUrl"
      :dependent-attribute-name="filterAttributeName"
      :dependent-relation-ship-name="dependentRelationShipName"
      :show-vlist="showVlist"
      :name-field="nameField"
      :id-field="idField"
      :display-fields="dialogDisplayFields"
      :orderby-fields="dialogOrderbyFields"
      :filter-fields="dialogFilterFields"
      :condition-fields="conditionValue"
      :show-remove-dialog="showRemoveDialog"
      :count-type="countType"
      :return-total-record-count="returnTotalRecordCount"
      :is-watch-loading="isLookupWatchLoading"
      :default-view-logical-name="defaultViewLogicalName"
      :default-view-id="defaultViewId"
      :customer-data="customerData"
      :lookup-value="lookupValue"
      :to-entity="fullEditForm"
      @data-selected="handleDataSelected"
      @dialogCallback="_dialogCallback"
    >
    </rt-lookup-dialog>

    <rc-dialog
      v-model="showFormDialog"
      custom-class="plat-standard-dialog"
      :close-on-click-modal="false"
      :title="$_t('common.add', '新增')"
      :show-footer="false"
      size="large"
      :class="isShowClass"
    >
      <vformcore
        v-if="showFormDialog"
        :form-logical-name="addFormLogicalName"
        :is-lookup-add="true"
        :object-type-name="entity"
        :form-type="1"
        :to-entity="fullEditForm"
        is-dialog-mode
        @callback="vformcallback"
      >
      </vformcore>
    </rc-dialog>
  </div>
</template>

<script>
import RtLookupDialog from './lookup-dialog';
import dialogMixin from './dialogMixin.js';
export default {
  name: 'RtPlatLookup',
  components: {
    'rt-lookup-dialog': RtLookupDialog
  },
  mixins: [dialogMixin],
  props: {
    value: {
      type: Object,
      required: false
    },
    fullEditForm: {
      type: Object
    },
    valueId: {
      type: String,
      required: false
    },
    disabled: Boolean,
    readonly: Boolean,
    routername: {
      type: String,
      required: false
    },
    showRemoveDialog: {
      type: Boolean,
      default: true
    },
    entity: {
      type: String,
      required: true
    },
    requestUrl: {
      type: String,
      default: function () {
        return 'api/crmlookupview/getdata';
      }
    },
    placeholder: {
      type: String,
      required: false,
      default: function () {
        return '';
      }
    },
    isNormal: Boolean,
    nameField: String,
    idField: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: {
      type: String,
      default: function () {
        return '';
      }
    },
    dialogFilterFields: String,
    dialogCallback: Function,
    dialogConditionFields: String,
    dependentAttributeName: {
      type: String, // 额外的过滤属性名称.
      required: false
    },
    dependentAttributeDisplayName: String, // 用于提示请先输入XXX.
    filterAttributeName: String,
    filterAttributeValue: {
      // 额外的过滤属性对应的值.
      type: [String, Object, Number, Array],
      required: false
    },
    dependentRelationShipName: String, // 依赖关系
    datafieldname: String, // 绑定的字段
    countType: {
      type: Number,
      default: 0
    },
    returnTotalRecordCount: {
      type: Boolean,
      default: true
    },
    // 启用跳转
    enableJump: {
      type: Boolean,
      default: false
    },
    jumpFormLogicaName: {
      type: String,
      required: false
    },
    jumpUrl: {
      type: String,
      required: false
    },
    // 获取跳转地址方法，这里时自定义脚本
    getJumpUrl: {
      type: Function,
      required: false
    },
    // 启用新增
    enableAdd: {
      type: Boolean,
      default: false
    },
    addFormLogicalName: {
      type: String,
      required: false
    },
    defaultViewLogicalName: {
      type: String,
      required: false
    },
    defaultViewId: {
      type: String,
      required: false
    },
    // 是否显示视图
    showVlist: {
      type: Boolean,
      default: true
    },
    isDependcy: {
      type: Number,
      default: 0
    },
    // lookup跳转是否有提示
    isNeedTips: {
      type: Boolean,
      default: false
    },
    // lookup绑定实体名称
    referencedEntityDisplayName: {
      type: String,
      default: ''
    },
    customerData: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    // 主档状态
    formStatus: {
      type: Number,
      default: 0
    },
    // 明细上主档的字段
    subGridRefAttribute: {
      type: String,
      default: ''
    },
    /**
     * 关闭快速搜索
     */
    closeQuickQuery: {
      type: Boolean,
      default: function () {
        return false;
      }
    }
  },
  data() {
    return {
      lookupValue: {
        name: null,
        id: null,
        logicalname: null
      },
      isChanged: false,
      lookupValueName: null,
      showFormDialog: false,
      list: [],
      lookupKey:
        'plat-base-autocomplete-suggestion el-autocomplete-suggestion_' +
        parseInt(Math.random() * 1000),
      enableBlur: true // 是否允许输入框失焦
    };
  },
  computed: {
    isLookupWatchLoading() {
      return !!(
        this.defaultViewLogicalName &&
        this.defaultViewId &&
        this.showVlist
      );
    },
    conditionValue: function () {
      return this.dialogConditionFields;
    },
    showJump: function () {
      return this.lookupValue && this.lookupValue.id && this.enableJump;
    },
    selectString: {
      get() {
        // 将idField、nameField、dialogDisplayFields合并，并去掉重复的字段
        var selectFields = [];
        selectFields.push(this.nameField);
        selectFields.push(this.idField);
        for (var i in this.dialogDisplayFields) {
          var fieldName = this.dialogDisplayFields[i].name;
          if (selectFields.indexOf(fieldName) >= 0) {
            continue;
          }
          if (this.dialogDisplayFields[i].noSelect) continue;
          selectFields.push(fieldName);
        }
        return selectFields.join(',');
      }
    },
    lookupValueReadOnly() {
      if (!this.disabled && !this.readonly) {
        return 'lookupvalue';
      } else {
        return 'lookupvalue isreadOnly';
      }
    },
    placeholderValue() {
      if (this.value && JSON.stringify(this.value) !== '{}') return '';
      if (this.disabled || this.readonly) return '--';
      return this.placeholder || this.$_t('common.select', '请选择');
    },
    // 模糊搜索显示数量
    autoCompleteCount() {
      return 20;
    },
    newLookupKey() {
      return (
        this.lookupKey &&
        this.lookupKey.replace('plat-base-autocomplete-suggestion ', '')
      );
    }
  },
  watch: {
    showFormDialog(newValue) {
      this.createListening(newValue);
    },
    value(newValue) {
      if (!newValue) {
        newValue = {
          name: null,
          id: null,
          logicalname: null
        };
      }
      this.lookupValue = newValue;
      // 处理掩码字段
    },
    valueId(newValueId) {
      var requestStr =
        this.requestUrl +
        '?page=1' +
        `&count=${this.autoCompleteCount}` +
        '&queryStr=';
      rt.get(requestStr)
        .then((res) => {
          if (res == null || res.Data == null) return;
          var list = [];
          res.Data.forEach((element) => {
            element.value = element[this.nameField];
            list.push(element);
            if (element.Id == newValueId) {
              this.selectValue(element);
            }
          });
        })
        .catch((error) => {
          rt.showErrorToast(error);
        });
    },
    lookupValueName(newValue, oldValue) {
      if (
        !newValue &&
        !newValue != !oldValue &&
        this.value &&
        this.value.name != newValue
      ) {
        this.lookupValue = null;
        this.$emit('input', this.lookupValue, null, this.datafieldname);
        this._dialogCallback(this.lookupValue);
      }
      // 如果输入框没值，则清空上次的搜索结果
      if (!newValue) {
        this.list = [];
      }
      // fix 68800
      //   if (
      //     (!oldValue && newValue) ||
      //     (newValue && oldValue && newValue != oldValue)
      //   ) {
      //     this.isChanged = true;
      //   } else {
      //     this.isChanged = false;
      //   }
    },
    isDependcy(newValue) {
      // 是否需要清除下一级
      if (newValue) {
        this.$emit('input', this.lookupValue, this.value, this.datafieldname);
      }
    }
  },
  beforeDestroy() {
    let lookupAutocompleteDOM = document.querySelector('.' + this.newLookupKey);
    if (lookupAutocompleteDOM) {
      lookupAutocompleteDOM.removeEventListener(
        'mouseover',
        this.closeBlurHandle
      );
      lookupAutocompleteDOM.removeEventListener(
        'mouseleave',
        this.openBlurHandle
      );
    }
  },
  mounted() {
    this.lookupValue = this.value;
    // 处理掩码字段
    if (this.value && typeof this.value.name == 'object') {
      this.lookupValue.name = this.value.name.text;
    }
    if (this.lookupValue) {
      // 处理掩码字段
      // 明细新增时，处理映射
      if (this.formStatus === 0 && this.subGridRefAttribute) {
        // 派发映射事件【事件内部做了触发条件限制，所以此处直接派发即可】
        this._fieldMappingHandle(this.lookupValue);
      }
    }

    /**
     * 监听 el-autocomplete 的下拉列表 要确定唯一性
     * 移入时，禁止失焦
     * 移出时，允许失焦
     */
    this.$nextTick(() => {
      let lookupAutocompleteDOM = document.querySelector(
        '.' + this.newLookupKey
      ); //
      this.eventListenerHook(
        this,
        'mouseover',
        this.closeBlurHandle,
        lookupAutocompleteDOM
      );
      this.eventListenerHook(
        this,
        'mouseleave',
        this.openBlurHandle,
        lookupAutocompleteDOM
      );
    });
  },
  methods: {
    eventListenerHook(thisVue, eventKey, eventHander, dom = window, useCapture = false,trigger="beforeDestroy") {
    dom.addEventListener(eventKey, eventHander, useCapture);
    if (!thisVue) {
        return;
    }
    thisVue.$once(`hook:${trigger}`, () => {
        dom.removeEventListener(eventKey, eventHander);
    });
    //需要做个兜底销毁，防止其他hook无法触发
    if(trigger!="beforeDestroy"){
        thisVue.$once("hook:".concat('beforeDestroy'), function () {
            dom.removeEventListener(eventKey, eventHander);
        }); 
    }
},
    changeLookupValueName() {
      this.isChanged = true;
    },
    focus() {
      this.isChanged = false;
    },
    /**
     * @description: lookup下拉选项和输入内容相同手动触发change校验
     * @return {*}
     */
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
   
    corpId(row) {
      return '';
    },
    clearData() {
      this.lookupValue = null;
      this.$emit('input', this.lookupValue, null, this.datafieldname);
      this._dialogCallback(this.lookupValue);
    },
    closeBlurHandle() {
      this.enableBlur = false;
    },
    openBlurHandle() {
      this.enableBlur = true;
    },
    _dialogCallback(value) {
      if (this.dialogCallback) {
        this.dialogCallback(value);
      }
      if (!value) {
        // 移除值 直接清空
        this.$emit('input', null, null, this.datafieldname);
      }
      this.$emit('dialogCallback', value);
      this.$emit('change', value);
      this._fieldMappingHandle(value);
    },
    /** 字段映射 */
    _fieldMappingHandle(value) {
      this.$emit(
        'attributeMappingCallback',
        value,
        this.lookupValue,
        this.datafieldname,
        this.entity
      );
    },
    blur(val) {
      // 子网格lookup
      let forSubgridlookup = {
        lookupVal: val.target.value,
        list: this.list,
        nameField: this.nameField,
        idField: this.idField,
        entity: this.entity
      };
      this.$emit('setValueToSubgridLookup', forSubgridlookup);
      // fix: 55454 全量测试【此处判断未能重现不相等的情况，暂时注释】
      // if (val.target.value == this.lookupValueName) {
      // 	return
      // }
      if (!this.enableBlur) return;
      if (!this.isChanged) return;
      if (this.list && this.list.length == 1) {
        // 如果有搜索结果，则手动调用选择事件
        this.selectValue(this.list[0]);
      } else if (
        !this.list ||
        (this.list && Array.isArray(this.list) && this.list.length == 0)
      ) {
        // 如果没有搜索结果，则清空输入内容
        this.lookupValueName = null;
      }
      if (this.lookupValue != null && this.lookupValue.id) {
        if (this.lookupValueName != this.lookupValue.name) {
          this.lookupValue = null;
          this.$emit('input', this.lookupValue, null, this.datafieldname);
          this._dialogCallback(this.lookupValue);
        }
      } else {
        this.lookupValue = null;
        this.$emit('input', this.lookupValue, null, this.datafieldname);
        this._dialogCallback(this.lookupValue);
      }
    },

    showLookupDialog() {
      // 通知子网格中的lookup
      this.$emit('showLookupDialog');
      if (this.disabled || this.readonly) {
        return false;
      }
      // else if (this.filterAttributeName && !this.filterAttributeValue) {

      // 	rt.showErrorToast(
      // 		this.$_t("lookup.error_msg", '请先选择或输入') +
      // 		this.dependentAttributeDisplayName
      // 	);
      // }
      else {
        if (this.$refs.lookupDialog) {
          this.$refs.lookupDialog.show();
        }
      }
    },
    handleDataSelected(val) {
      if (!val) {
        val = {};
      }
      this.lookupValue = val;
      // 处理掩码字段
      this.$emit('input', val, null, this.datafieldname);
    },
    // 数据加载
    // 数据加载
    findValueByApi(queryString, callbackFun) {
      console.log('lookup加载数据');
      if (queryString != null && queryString.length > 0) {
        // if (this.filterAttributeName && !this.filterAttributeValue) {
        // 	rt.showErrorToast(
        // 		this.$_t("lookup.error_msg", "请先选择或输入") +
        // 		this.dependentAttributeDisplayName
        // 	);
        // 	this.lookupValue = null;
        // 	this.lookupValueName = "";
        // 	callback([]);
        // 	return;
        // }
        var requestStr = '';
        var isUrl = false;
        if (this.requestUrl) {
          if (this.requestUrl.split('?').length > 1) {
            isUrl = true;
          } else {
            isUrl = false;
          }
        }
        var isEntities = false;
        if (this.isNormal) {
          requestStr =
            this.requestUrl +
            (isUrl ? '&page=' : '?page=') +
            '1' +
            `&count=${this.autoCompleteCount}` +
            '&queryStr=' +
            queryString +
            '&filter=' +
            this.nameField +
            '&filterValue=' +
            queryString;
        } else {
          if (
            this.requestUrl.indexOf('api/vlist/ExecuteQuery') >= 0 &&
            this.requestUrl.indexOf('api/vlist/ExecuteQueryForLookUp') === -1
          ) {
            isEntities = true;
            requestStr =
              this.requestUrl +
              (isUrl ? '&isPreview=' : '?isPreview=') +
              'false&$pageSize=' +
              this.autoCompleteCount +
              '&$pageIndex=1&$paging=true' +
              '&$search=' +
              encodeURIComponent(this.lookupValueName || '');
            if (this.filterAttributeName) {
              requestStr += '&relationFilterAttribute=';
              requestStr += this.filterAttributeName;
            }
            if (this.filterAttributeValue) {
              requestStr += '&relationFilterValue=';
              requestStr += this.filterAttributeValue;
            }
          } else {
            let nameField = this.nameField;
            if (
              this.requestUrl.indexOf('api/vlist/ExecuteQueryForLookUp') >= 0
            ) {
              nameField = ''; // 当请求这个接口的时候，将filter要传的值置空
            }
            requestStr =
              this.requestUrl +
              (isUrl ? '&entityName=' : '?entityName=') +
              this.entity +
              '&page=1&count=' +
              this.autoCompleteCount +
              '&select=' +
              this.selectString +
              '&orderby=' +
              this.dialogOrderbyFields +
              '&filter=' +
              nameField +
              '&filterValue=' +
              encodeURIComponent(this.lookupValueName || '');
            if (this.conditionValue) {
              requestStr += '&condition=';
              requestStr += encodeURIComponent(this.conditionValue);
            }
          }
        }
        // 分页信息
        requestStr +=
          '&countType=' + this.countType + '&returnTotalRecordCount=false';
        rt.get(requestStr)
          .then((res) => {
            if (isEntities) {
              if (res == null || res.Entities == null) {
                callbackFun([]);
                return;
              }
              this.list = [];
              res.Entities.forEach((element) => {
                element.value = element[this.nameField];
                // 处理掩码字段
                for (let key in element) {
                  if (
                    element[key] &&
                    typeof element[key] == 'object' &&
                    element[key].hasOwnProperty('reference')
                  ) {
                    element[key] = element[key].text;
                  }
                }
                this.list.push(element);
              });
              callbackFun(this.list);
            } else {
              if (res == null || res.Data == null) {
                callbackFun([]);
                return;
              }
              this.list = [];
              res.Data.forEach((element) => {
                element.value = element[this.nameField];
                // 处理掩码字段
                for (let key in element) {
                  if (
                    element[key] &&
                    typeof element[key] == 'object' &&
                    element[key].hasOwnProperty('reference')
                  ) {
                    element[key] = element[key].text;
                  }
                }
                this.list.push(element);
              });
              callbackFun(this.list);
            }
          })
          .catch((error) => {
            callbackFun([]);
            rt.showErrorToast(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        callbackFun([]);
      }
    },
    selectValue(value) {
      if (value) {
        // 处理掩码字段
        let name =
          typeof value[this.nameField] == 'object'
            ? value[this.nameField].text
            : value[this.nameField];
        this.lookupValue = {
          name: name,
          id: value[this.idField] || value.$id,
          logicalname: this.entity
        };
        // 处理掩码字段
        this.$emit('input', this.lookupValue, null, this.datafieldname);
        this._dialogCallback(this.parseVal(value));
        if (this.$refs.lookupDialog) {
          this.$refs.lookupDialog.currentRowClick = null;
        }
        if (this.lookupValueName == name) {
          this.dispatch('ElFormItem', 'el.form.change', [this.lookupValueName]);
        }
      }
    },
    jumpNeedTips() {
      if (this.isNeedTips == true) {
        this.$confirm(
          this.$_t(
            'JumpisNeedTips',
            '跳转详情页面可能会导致当前页面刚刚已编辑的数据丢失，是否继续？'
          ),
          this.$_t('Tip', '步骤'),
          {
            confirmButtonText: this.$_t('BUTTON_DETERMINE', '确定'),
            confirmButtonClass: 'ConfirmButtonClass',
            cancelButtonText: this.$_t('BUTTON_CANCEL', '取消'),
            cancelButtonClass: 'CancelButtonClass',
            type: 'warning'
          }
        ).then(() => {
          window.formDataChanged = false;
          this.jumpEdit();
        });
      } else {
        this.jumpEdit();
      }
    },
    // 跳转到别的页面
    jumpEdit(newPage = false) {
      if (!this.lookupValue || !this.lookupValue.id) {
        return '';
      }
      let url = '';
      if (this.routername) {
        if (!newPage) {
          this.$router.push({
            name: this.routername,
            params: {
              id: this.lookupValue.id
            }
          });
        } else {
          url = this.routername
            ? (this.routername&&this.routername.toLowerCase())
            : '' + this.lookupValue.id;
        }
        return url;
      }

      if (this.jumpUrl) {
        if (!newPage) {
          let params = this.getJumpUrl(this.lookupValue.id);
          if (params) {
            this.$router.push(params);
          }
        } else {
          let params = this.getJumpUrl(this.lookupValue.id);
          if (params) {
            url = params.slice(1);
          }
          //   fix 62317 这里的逻辑有问题，时间太久了忘记为啥之前这样写了，也没测出来问题
          //   url = params.name
          //     ? params.name.toLowerCase()
          //     : '' + this.lookupValue.id;
        }
        return url;
      }
      if (this.jumpFormLogicaName) {
        if (!newPage) {
          this.$router.push({
            name: 'VForm3',
            params: {
              entityName: this.entity,
              formLogicalName: this.jumpFormLogicaName,
              id: this.lookupValue.id
            }
          });
        } else {
          url =
            'vform3/' +
            this.entity +
            '/' +
            this.jumpFormLogicaName +
            '/' +
            this.lookupValue.id;
        }
        return url;
      }
      if (!newPage) {
        this.$router.push({
          path: '/vform/' + this.entity + '/' + this.lookupValue.id
        });
      } else {
        return 'vform/' + this.entity + '/' + this.lookupValue.id;
      }
    },
    getFunctionByExpression(expression, argNames) {
      try {
        var isFun = expression.replace(/(^\s*)|(\s*$)/g, '').indexOf('{') == 0;
        if (argNames && argNames.length > 0) {
          return new Function(
            argNames,
            `${isFun ? '' : 'return'} ${expression}`
          );
        } else {
          return new Function(`${isFun ? '' : 'return'} ${expression}`);
        }
      } catch (error) {
        if (!sessionStorage.showException) {
          sessionStorage.showException = true;
          rt.showErrorToast(
            this.$_t('platform.lookupScript', '脚本') +
              expression +
              this.$_t('platform.lookupPerformerror', '执行出错,请检查正确性')
          );
        }
        setTimeout(() => {
          sessionStorage.showException = '';
        }, 1000);
        return new Function('return null');
      }
    },
    // 显示新增窗体
    showAddForm() {
      this.showFormDialog = true;
    },
    // 回调
    vformcallback(value) {
      this.selectValue(value);
      this.showFormDialog = false;
    },
    // 动态表单后 lookup为对象 改为兼容老的逻辑
    // 比如 orderid{id:idxx,name:namexx} 改为 orderid:namexx orderid.id:idxx
    parseVal(val) {
      var newValue = {};
      for (var key in val) {
        let obj = val[key];
        if (obj != null && typeof obj == 'object') {
          if (obj.name) {
            newValue[key] = obj.name;
          }
          if (obj.id) {
            newValue[key + '.id'] = obj.id;
          }
          // 处理掩码字段
          if (obj.hasOwnProperty('reference')) {
            newValue[key] = obj.text;
          }
        } else {
          newValue[key] = obj;
        }
      }
      return newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
// 处理无边框界面
.rc-base-lookup.plat-base-lookup.hasprefixicon {
  .el-input__inner {
    padding-left: 24px;
  }
  .jumpSpan {
    left: 24px;
    max-width: calc(100% - 58px);
  }
}
// 处理无边框界面
.rc-base-lookup.plat-base-lookup {
  .plat-base-input {
    width: 100%;
    .el-input__suffix {
      .rt-icon {
        align-items: center;
      }
    }
  }
  .rc-base-lookup-add {
    cursor: pointer;
    position: absolute;
    bottom: 24px;
    right: 0;
    display: flex;
    color: #0073e6;
    font-size: 14px;
    align-items: center;
    .rt-icon {
      color: #0073e6;
      margin-right: 4px;
      display: flex;
      align-items: center;
    }
  }
  .lookupvalue {
    height: 28px;
    box-sizing: border-box;
    border-bottom: 1px solid #d3d9de;
    position: relative;
    display: flex;
    align-items: center;
    .jumpSpan {
      top: 0;
      bottom: 0;
      max-width: calc(100% - 25px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 27px;
      position: absolute;
      color: #0073e6;
      height: unset;
      font-size: 14px;
      background: #fff;
      text-decoration: underline;
      cursor: pointer;
      // z-index: 9;
    }
    .suffix-icon-wrap {
      height: 28px;
      width: 16px;
      display: flex;
      align-items: center;
      position: absolute;
      right: 8px;
      .rt-icon.lookup {
        display: flex;
        align-items: center;
        color: #21262c;
        cursor: pointer;
      }
    }
  }
}
.is-border-form.el-form {
  .is-error {
    .rc-base-lookup.plat-base-lookup {
      ::v-deep input {
        outline: none;
        border-color: #f44725;
      }
    }
  }
  .rc-base-lookup.plat-base-lookup {
    position: relative;
    .rc-lookup-qywx {
      height: 28px;
      color: #143e81;
      line-height: 28px;
      border-bottom: 1px #e8ecfc solid;
      .el-input__suffix {
        cursor: pointer;
      }
    }
    .rc-base-lookup-add {
      cursor: pointer;
      position: absolute;
      bottom: 42px;
      right: 0;
      display: flex;
      color: #0073e6;
      font-size: 14px;
      align-items: center;
      .rt-icon {
        color: #0073e6;
        margin-right: 4px;
        display: flex;
        align-items: center;
      }
    }
    ::v-deep input {
      padding-left: 8px;
      border-radius: 4px;
      width: 100%;
    }
    ::v-deep .plat-base-input {
      width: 100%;
      .el-input--prefix {
        input {
          padding-left: 24px;
        }
      }
      .el-input__suffix {
        right: 8px;
        .rt-icon {
          color: #21262c;
          align-items: center;
        }
      }
    }
    .lookupvalue {
      border-radius: 4px;
      height: 35px;
      box-sizing: border-box;
      border: 1px solid #d6dbe1;
      position: relative;
      display: flex;
      align-items: center;
      .jumpSpan {
        left: 8px;
        top: 0;
        bottom: 0;
        max-width: calc(100% - 25px);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 35px;
        position: absolute;
        color: #0073e6;
        height: unset;
        font-size: 14px;
        background: #fff;
        text-decoration: underline;
        cursor: pointer;
        // z-index: 9;
      }
      .suffix-icon-wrap {
        height: 35px;
        width: 16px;
        display: flex;
        align-items: center;
        position: absolute;
        right: 7px;
        .rt-icon.lookup {
          color: #21262c;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .rt-icon.select_icon {
        left: 8px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .lookupvalue.isreadOnly {
      background: #f0f2f4;
      border: none;
      color: #0b0c0e;
      .jumpSpan {
        background: none;
        text-decoration: none;
        // align-items: center;
        // display: flex;
      }
    }
  }
  //新加
  .rc-base-lookup.plat-base-lookup.hasprefixicon {
    .lookupvalue {
      padding-left: 8px;
      .rt-icon.select_icon {
      }
    }
    input {
      padding-left: 24px;
    }
    .rt-icon {
      top: unset;
    }
    .el-input__prefix {
      display: flex;
      align-items: center;
      justify-content: center;
      .rt-icon {
        left: 8px;
        position: relative;
        top: 0;
      }
    }
    .jumpSpan {
      left: 32px;
      max-width: calc(100% - 58px);
      line-height: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// plat-lookup.vue?240470d5